// formSlice.ts

import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { form } from '../../../enums/form.enum';
import { slice } from '../../../enums';

interface FormState {
  currentForm?: form | null,
  isFormSubmitted: { [key in form]?: boolean }; // Use enum keys as keys of isFormSubmitted
  data: {
    [key: string]: any;
  };
}

const initialState: FormState = {
  isFormSubmitted: Object.keys(form).reduce((acc, key) => {
    acc[key] = false; // Initialize all forms as not submitted
    return acc;
  }, {} as { [key in form]?: boolean }),
  data: {},
};

const formSlice = createSlice({
  name: slice.FORM,
  initialState,
  reducers: {
    setCurrentForm: (state: Draft<FormState>, action: PayloadAction<form>) =>{
      state.currentForm = action.payload;
    },
    resetCurrentForm: (state) =>{
      state.currentForm = null;
    },

    submitForm: (state: Draft<FormState>, action: PayloadAction<form>) => {
      state.isFormSubmitted[action.payload] = true;  
    },
  
    resetSubmitForm: (state: Draft<FormState>, action: PayloadAction<form>) => {
      state.isFormSubmitted[action.payload] = false;  
    },

    updateFormData: (state, action: PayloadAction<{ key: string; value: any }>) => {
      const { key, value } = action.payload;
      state.data[key] = value;
    },
  },
});

export const { updateFormData,setCurrentForm, resetCurrentForm, resetSubmitForm, submitForm } = formSlice.actions;
export const formReducer = formSlice.reducer;
